import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

if (!environment.production) {
  console.info('[Taskeo] API base (config):', environment.apiUrl);
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
